import React, {Component} from 'react';
import axios from "axios";

import inst from "../../../../assets/logos/instant_3.svg";
import up from "../../../../assets/logos/fleche_up.svg";
import down from "../../../../assets/logos/fleche_up.svg";
import acheter from "../../../../assets/logos/bouton_acheter.svg";

export default class InstantCreator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.user,
            id: this.props.id,
            instants: null,
            videos: null,
        }
    }

    componentDidMount() {
        let url = import.meta.env.VITE_BACKEND_URL + '/instant/getcreator';
        axios.post(url, {
                id: this.state.id,
            },
            {
                headers: {
                    Authorization: 'Bearer ' + this.state.user.token
                }
            }).then(response => {
            this.setState({instants: response.data.instants, videos: response.data.videos});
        }).catch(error => {
            console.log('Config:', error.config);
        })
    }

    formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }

    handleVideoSimple = (element,type, index) => {
        const {videos, instants} = this.state;
        console.log('handleVideoSimple', element, type, index);
        if(element === 'possede'){
            if(type === 'simple'){
                let video = instants[index];
                let url = "/video/" + video.video.token + "/" + video.startTime;
                window.location.href = url;

            }else{
                let video = instants[index];
                let url = "/instant/" + video.video.token + "/" + video.startTime;
                window.location.href = url;
            }
        }else{
            if(type === 'simple'){
                let video = videos[index];
                let url = "/video/" + video.video.token + "/" + video.startTime;
                window.location.href = url;
            }else{
                let video = videos[index];
                let url = "/instant/" + video.video.token + "/" + video.startTime;
                window.location.href = url;
            }
        }
    }

    render() {
        return (
            <div className="creatorInstant">
                <div className="instantcreateur">
                    <div className="title">
                        <h2>Instants du créateur</h2>
                        <div className="line">
                            <div className="block_line">
                                <h2>40 762 MATIC</h2>
                                <p>Volume total<br/>
                                    de vente</p>
                            </div>
                            <div className="block_line">
                                <h2><img src={up} alt=""/> +4%</h2>
                                <p>Tendance<br/>
                                    du marché</p>
                            </div>
                            <div className="block_line">
                                <h2>65€</h2>
                                <p>Prix de la<br/>
                                    meilleure vente</p>
                            </div>
                            <div className="block_line">
                                <h2>141</h2>
                                <p>Nombre<br/>
                                    d’owners</p>
                            </div>
                            <div className="block_line">
                                <h2>29</h2>
                                <p>Nombre d’unique<br/>
                                    owners</p>
                            </div>
                        </div>
                    </div>
                    <div className="block_line_video">
                        {
                            this.state.videos !== null &&
                            this.state.videos.map((instant, index) => (
                                <div key={index} className="block_line">
                                    <div className="image_block" onClick={() => this.handleVideoSimple('createur','simple',index)}>
                                        <img src={`${import.meta.env.VITE_BACKEND_URL_IMG}${instant.video.miniature}`}
                                             alt=""/>
                                        <div className="round_background">
                                            <img src={inst} alt=""/>
                                        </div>
                                        <div className="time">
                                            <p>{this.formatTime(instant.startTime)}</p>
                                        </div>
                                    </div>
                                    <div className="info_instant" onClick={() => this.handleVideoSimple('createur','instant',index)}>
                                        <div className="title_video">
                                            <p>{instant.video.title}</p>
                                            <p>{instant.price}€</p>
                                        </div>
                                        <div className="creator_block">
                                            <p>{instant.creator.nom_artiste}</p>
                                            <p><img src={up} alt=""/> +3</p>
                                        </div>
                                        <div className="message_video">
                                            <p>{instant.message}</p>
                                            <p>Plus d’informations sur le NFT</p>
                                        </div>
                                        <div className="block_button">
                                            <img src={acheter} alt=""/>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className="instantposede">
                    <div className="title">
                        <h2>Instants possédés</h2>
                        <div className="line">
                            <div className="block_line">
                                <h2>40 762 MATIC</h2>
                                <p>Volume total<br/>
                                    de vente</p>
                            </div>
                            <div className="block_line">
                                <h2><img src={up} alt=""/> +4%</h2>
                                <p>Tendance<br/>
                                    du marché</p>
                            </div>
                            <div className="block_line">
                                <h2>65€</h2>
                                <p>Prix de la<br/>
                                    meilleure vente</p>
                            </div>
                            <div className="block_line">
                                <h2>141</h2>
                                <p>Nombre<br/>
                                    d’owners</p>
                            </div>
                            <div className="block_line">
                                <h2>29</h2>
                                <p>Nombre d’unique<br/>
                                    owners</p>
                            </div>
                        </div>
                    </div>
                    <div className="block_line_video">
                        {
                            this.state.instants !== null &&
                            this.state.instants.map((instant, index) => (
                                <div key={index} className="block_line">
                                    <div className="image_block" onClick={() => this.handleVideoSimple('possede','video',index)}>
                                        <img src={`${import.meta.env.VITE_BACKEND_URL_IMG}${instant.video.miniature}`}
                                             alt=""/>
                                        <div className="round_background">
                                            <img src={inst} alt=""/>
                                        </div>
                                        <div className="time">
                                            <p>{this.formatTime(instant.startTime)}</p>
                                        </div>
                                    </div>
                                    <div className="info_instant" onClick={() => this.handleVideoSimple('possede','instant',index)}>
                                        <div className="title_video">
                                            <p>{instant.video.title}</p>
                                            <p>{instant.price}€</p>
                                        </div>
                                        <div className="creator_block">
                                            <p>{instant.creator.nom_artiste}</p>
                                            <p><img src={up} alt=""/> +3</p>
                                        </div>
                                        <div className="message_video">
                                            <p>{instant.message}</p>
                                            <p>Plus d’informations sur le NFT</p>
                                        </div>
                                        <div className="block_button">
                                            <img src={acheter} alt=""/>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        )
    }
}